<template>
  <div id="app" :style="appStyle">
    <myHeaderVue
      ref="headerRef"
      v-if="showHeader && !['/fullScreen', '/login','/map'].includes(currentPath)"
    />
    <div class="center_content" :style="contentStyle">
      <router-view v-if="isCreatePage" />
    </div>
    <myFooterVue
      ref="footerRef"
      v-if="
        !['/','/graph', '/postureMap','/industryAnalysis', '/fullScreen', '/login','/map'].includes(
          currentPath
        )
      "
    />
    <div v-if="scrollHeight> 500" class="to_top_btn flex jc_ctr  align_items_ctr pointer" @click="toTopClick">
      <img src="./assets/imgs/toTop.svg" alt="">
    </div>
  </div>
</template>

<script>
import myFooterVue from "./components/myFooter.vue";
import myHeaderVue from "./components/myHeader.vue";
// import { getIPApi } from "@/apis/api";
import { mapState } from "vuex";
export default {
  name: "App",
  components: { myFooterVue, myHeaderVue },
  provide() {
    return {
      reload: this.reload,
      hideShowHeader: this.hideShowHeader,
    };
  },
  data() {
    return {
      headerHeight: 0,
      footerHeight: 0,
      showHeader: true,
      scrollHeight:0
    };
  },
  computed: {
    ...mapState(["isCreatePage"]),
    contentStyle() {
      let height = `calc( 100vh - ${this.headerHeight + this.footerHeight}px)`;
      this.$store.commit("setContentHeight", height);
      return {
        minHeight: height,
        background: ["/", "/login"].includes(this.$route.path)
          ? "transparent"
          : "transparent",
      };
    },
    currentPath() {
      return this.$route.path;
    },
    appStyle() {
      if (['/login','/',"/graph",'/postureMap',"/industryAnalysis"].includes(this.currentPath)) {
        return {
          background: `url(${require("./assets/imgs/whole_bg.png")}) no-repeat`,
          "background-size": "100% 100%",
        };
      } else {
        return {};
      }
    },
  },
  async mounted() {
    // this.getHeaderHeight();
    // this.getFooterHeight();
    try {
      // let res = await getIPApi();
      this.$store.commit("setIp", res.data);
    } catch (error) { }
    window.addEventListener("scroll", this.handleScroll);
  },
  beforeDestroy() {
    // 组件销毁时移除事件监听，防止内存泄漏
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    getHeaderHeight() {
      this.$nextTick(() => {
        this.headerHeight = this.$refs.headerRef.$el.offsetHeight;
        console.log(this.headerHeight, "headerHeight");
      });
    },
    getFooterHeight() {
      this.$nextTick(() => {
        this.footerHeight = this.$refs.footerRef.$el.offsetHeight;
        console.log(this.footerHeight, "footerHeight");
      });
    },
    reload() {
      this.$store.commit("isCreatePage", false);
      this.$nextTick(() => {
        this.$store.commit("isCreatePage", true);
      });
    },
    hideShowHeader() {
      this.showHeader = !this.showHeader;
      if (this.showHeader == false) {
        this.headerHeight = 0;
      }
    },
    toTopClick() {
      window.scrollTo({ top:'0',behavior: 'smooth' });
    },
    handleScroll() {
      // 获取当前滚动高度
      this.scrollHeight = window.scrollY;
    }
  },
  watch: {
    "$route.path"(n, o) {
      // 设置图谱页底部高度为0
      if (n == "/graph" || n=="/postureMap") {
        this.footerHeight = 0;
      }
      if (n == "/industryAnalysis") {
        this.footerHeight = 0;
      }
      if (["/login", "/fullScreen",'/map'].includes(n)) {
        this.headerHeight = 0;
        this.footerHeight = 0;
      }
    },
  },
};
</script>
<style lang="less">
#app {
  .to_top_btn{
    position: fixed;
    bottom: 100px;
    right: 5%;
    background: #1E3C63;
    width: 68px;
    height: 68px;
    border-radius: 50%;
    >img{
      width: 50px;
      height: 50px;
    }
  }
}
</style>
